updatePromos();

function updatePromos() {
    const urlParams = new URLSearchParams(location.search);
    let promoCode = urlParams.get('promo');
    let promoOffer = urlParams.get('offer');
    let topApplyButton = document.getElementById('applyCoupon');
    
    updatePromoBar();
    hookupApplyPromo();

    function updatePromoBar() {
        let promoCodeDisplay = document.getElementById('checkout-promo-code');
        let promoOfferDisplay = document.getElementById('checkout-promo-offer');

        if (promoCode && promoOffer) {
            // Ensures promo code is upper case
            promoCode = promoCode.toUpperCase();

            // Populate promo code display
            promoCodeDisplay.innerHTML = promoCode;
            promoOfferDisplay.innerHTML = promoOffer;
        }
    }

    function applyPromoCode() {
        let checkoutPromoField = document.getElementsByName('simpay_field[coupon]');
        let  checkoutApplyButton = document.getElementsByClassName('simpay-apply-coupon');

        checkoutPromoField[0].value = promoCode;
        checkoutApplyButton[0].click();
        topApplyButton.innerText = 'Applying Savings...';
        window.setTimeout(promoSuccessMessage, 3000);
        
        // Possibly change text to a waiting message before success message appears.
        function promoSuccessMessage() {
            let simpayCouponMessage = document.getElementsByClassName('simpay-coupon-message')[0].textContent;
            
            if (! simpayCouponMessage || simpayCouponMessage == 'Coupon is invalid.') {
                topApplyButton.innerText = 'Promo Expired';
                console.log('Home ASAP: Promo bar button failed to update. Promo code is invalid or missing.');
            } else {
                topApplyButton.innerText = 'Success!';
                topApplyButton.classList.add('checkout-promo-success');
            }
        }
    }

    function hookupApplyPromo() {
        if (topApplyButton && promoCode) {
            topApplyButton.addEventListener('click', applyPromoCode);
        }
    }
}